class ProductMedia extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.layout = this.dataset.layout),
            (this.masonry_container = this.querySelector("[data-masonry-layout]")),
            (this.media = this.querySelectorAll(".product-media--root")),
            (this.modal = this.querySelector('[data-modal-view="product-media"]')),
            (this.playable_media = this.querySelectorAll(".product-model--root, .product-video--root")),
            (this.scroll_enabled = "true" == this.getAttribute("data-variant-scroll")),
            this.pauseListener(),
            this.updateMediaListeners(),
            this.masonry_container && ((this.gap = parseInt(this.masonry_container.dataset.gap)), this.getMasonryBlocks(), this.resizeObserver());
    }
    disconnectedCallback() {
        this.playable_media.off("click." + this.dataset.id), window.off(`theme:product:${this.dataset.id}:variantChanged.ProductMedia theme:product:${this.dataset.id}:mediaChanged.ProductMedia`);
    }
    pauseListener() {
        this.playable_media.on("click." + this.dataset.id, ({ target: t }) => {
            var e = t.closest(".product-model--root, .product-video--root");
            this.playable_media.not(e).forEach((t) => t.trigger("pauseMedia"));
        });
    }
    updateMediaListeners() {
        window.on(`theme:product:${this.dataset.id}:variantChanged.ProductMedia`, ({ detail: { variant: t } }) => {
            var e = t.featured_media ? parseInt(t.featured_media.id) : 0;
            this.updateVariantMedia(e, t.option1);
        }),
            window.on(`theme:product:${this.dataset.id}:mediaChanged.ProductMedia`, ({ detail: { id: t } }) => this.updateVariantMedia(t));
    }
    
    //   updateVariantMedia(a) {
    //     0 !== a &&
    //       this.media.forEach((t) => {
    //         var e = parseInt(t.dataset.id) === a;
    //         t.setAttribute("data-active", e),
    //           t.children[0].trigger(e ? "playMedia" : "pauseMedia"),
    //           e && ("one" == this.layout || "two" == this.layout ? this.scrollToMedia(parseInt(t.offset().top)) : ("mixed" == this.layout && this.updateMixedMedia(t), this.scrollToMedia(parseInt(this.offset().top))));
    //       });
    //   }
    updateVariantMedia(variantId, activeColor) {
        // Ensure variantId is not zero
        if (variantId !== 0 && this.scroll_enabled) {
            var activeColorVariant = activeColor;
            this.media.forEach((mediaElement) => {
                
                var isActive = parseInt(mediaElement.dataset.id) === variantId || mediaElement.dataset.id === variantId;
                var mediaAlt = mediaElement.getAttribute("data-media-alt");
                var colorVariant = mediaAlt ? mediaAlt.split("-")[0].trim() : null;
                if (isActive) {
                    activeColorVariant = colorVariant;
                }
            });
            this.media.forEach((mediaElement) => {
                // Check if the dataset id of the mediaElement matches the variantId
                var isActive = parseInt(mediaElement.dataset.id) === variantId;
                mediaElement.setAttribute("data-active", isActive);
                // Extract color from 'data-media-alt'
                var mediaAlt = mediaElement.getAttribute("data-media-alt");
                
                var colorVariant = mediaAlt ? mediaAlt.split("-")[0].trim() : null;
                if (activeColorVariant == colorVariant || colorVariant == "Size Chart") {
                    mediaElement.style.display = "flex";
                } else {
                    // Hide the media element if it's not active
                    mediaElement.style.display = "none";
                }
                // Continue with existing functionality
                if (isActive || activeColorVariant == colorVariant || colorVariant == "Size Chart") {
                    // Play or pause media based on its active state
                    mediaElement.firstChild.trigger(isActive ? "playMedia" : "pauseMedia");
                    // If the layout is 'one' or 'two', scroll to the media
                    // If the layout is 'mixed', update the mixed media
                    if (this.layout === "one" || this.layout === "two") {
                        this.setMasonryLayout();
                        // this.scrollToMedia(parseInt(mediaElement.offset().top));
                    } else if (this.layout === "mixed") {
                        this.updateMixedMedia(mediaElement);
                    }
                }
            });
        }
    }
    scrollToMedia(t) {
        var e, a;
        this.scroll_enabled &&
            "small" !== theme.mqs.current_window &&
            "thumbnails" != this.layout &&
            ((a = "" === (e = document.documentElement.style.getPropertyValue("--sticky-offset")) ? 0 : parseInt(e.replace("px", ""))), window.scrollTo({ top: t - a - 8, left: 0, behavior: "smooth" }));
    }
    updateMixedMedia(t) {
        var e = this.querySelector(".product-media--active .product-media--root");
        e && (this.swapMedia(t, e), (this.media = this.querySelectorAll(".product-media--root"))), this.masonry_container && this.getMasonryBlocks(), this.modal && this.updateModals(t.dataset.id);
    }
    updateModals(e) {
        var t = this.querySelectorAll(".modal--content"),
            a = [...t].find((t) => e === t.dataset.id);
        this.modal.updateLinks(), a && this.swapMedia(t[0], a);
    }
    swapMedia(t, e) {
        t.replaceWith(e.cloneNode(!0)), e.replaceWith(t.cloneNode(!0));
    }
    getMasonryBlocks() {
        (this.left_blocks = this.masonry_container.querySelectorAll(":scope > :nth-child(odd)")), (this.right_blocks = this.masonry_container.querySelectorAll(":scope > :nth-child(even)")), this.setMasonryLayout();
    }
    setMasonryLayout() {
        var t = this.getColumnHeight(this.left_blocks),
            e = this.getColumnHeight(this.right_blocks),
            a = e < t ? t + this.gap * (this.left_blocks.length - 1) : e + this.gap * (this.right_blocks.length - 1);
        // Removing this because it was getting set wrong on safari
        // this.masonry_container.style.height = a + 1 + "px";
    }
    getColumnHeight(t) {
        return Math.ceil([...t].reduce((t, e) => t + e.getBoundingClientRect().height, 0));
    }
    resizeObserver() {
        new ResizeObserver(() => this.setMasonryLayout()).observe(this.masonry_container);
    }
    hideVariantImages(variant_media_id, alt) {
        var _this, active_media;
        _this = this;
        active_media = null;
        _this.media_containers.attr("data-active", false);
        _this.media_containers.each(function (media_container, index) {
            var media_id;
            if (alt !== media_container.getAttribute("data-media-alt").trim().toLowerCase()) {
                //media_container.style.display = "none";
            } else {
                media_container.style.display = "block";
            }
            media_id = parseInt(media_container.getAttribute("data-id"));
            if (media_id === variant_media_id) {
                active_media = media_container;
                active_media.setAttribute("data-active", true);
            }
        });
    }
}
const productMediaEl = customElements.get("product-media-variants");
productMediaEl || customElements.define("product-media-variants", ProductMedia);
